module.exports = __webpack_public_path__ + "img/banner-dbsm-upgrade.0106b410.png";